import { useContext } from 'react';
import { ReprocessContext } from '../providers/reprocessContext';

/**
 * Hook to access the global reprocess context.
 * Must be used within a ReprocessProvider.
 *
 * @returns ReprocessContextType - The global reprocess state and functions
 * @throws Error if used outside of ReprocessProvider
 *
 * @example
 * ```tsx
 * const { handleReprocess, reprocessStatus, addSessionToReprocess } = useReprocess();
 *
 * const handleReprocessSession = async () => {
 *   addSessionToReprocess(session);
 *   await handleReprocess(invalidateSession);
 * };
 *
 * // Or process runs immediately without adding to state first:
 * const handleReprocessRun = async (run) => {
 *   await handleReprocess(invalidateSession, [run]);
 * };
 * ```
 */
export const useReprocess = () => {
  const context = useContext(ReprocessContext);
  if (!context) {
    throw new Error('useReprocess must be used within a ReprocessProvider');
  }
  return context;
};
